import { OccupationType, PropertyType } from 'constants/kycTypes'
import { IKycData } from 'interfaces/i-api-kyc'
import {
	FormatEnumToList,
	CountrySpecificValues,
	getAllCountriesUsingMarketSpecificSorting,
} from 'utils/helpers'
import { useTranslation } from 'react-i18next'
import { TranslationFile } from 'i18n'
import appConfig from 'app.config'

export const LoanInformationFormEe = (data: IKycData) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
	])
	return {
		fieldSetName: t('forms:LoanInfoHeader'),
		formName: 'FirstAndTwoThirds',
		description: t('forms:'),
		show: false,
		visible: true,
		controls: [
			{
				controlName: 'email',
				type: 'text',
				label: t('forms:Email'),
				col: 12,
				value: data.email,
				visible: true,
				maxLength: 254,
				required: true,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,6})$',
						message: t('ValidateEmailInvalid'),
					},
				],
			},
			{
				controlName: 'phoneNumber',
				type: 'text',
				label: t('forms:PhoneNumber'),
				col: 12,
				value: data.phoneNumber,
				visible: true,
				required: true,
				validations: [
					{
						code: 'MustBeNumeric',
						value: '^[0-9]+$',
						message: t('InvalidPhone'),
					},
					{
						code: 'MustMatchPattern',
						value: '^\\+?37((2\\d{7,8})|([01]\\d{8}))$',
						message: t('InvalidPhone'),
					},
				],
			},
			{
				options: getAllCountriesUsingMarketSpecificSorting(
					appConfig.country,
				),
				required: true,
				controlName: 'country',
				type: 'dropdown',
				label: t('forms:CountryOfResidence'),
				value: data.address.country,
				multiple: false,
				visible: true,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownCountry'),
			},
			{
				controlName: 'street',
				type: 'text',
				label: t('forms:Street'),
				col: 12,
				value: data.address.street,
				visible: true,
				required: true,
			},
			{
				controlName: 'postalCode',
				type: 'text',
				label: t('forms:PostalCode'),
				col: 12,
				value: data.address.postalCode,
				visible: true,
				required: true,
			},
			{
				controlName: 'city',
				type: 'text',
				label: t('forms:City'),
				col: 12,
				value: data.address.city,
				visible: true,
				required: true,
			},
			{
				options: FormatEnumToList(
					OccupationType,
					PropertyType.Occupation,
					TranslationFile.Dropdown,
				),
				required: true,
				controlName: 'occupationType',
				type: 'dropdown',
				label: t('forms:Occupation'),
				col: 12,
				value: data.employments[0].occupationType,
				visible: true,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownOccupationType'),
			},
			{
				options: CountrySpecificValues('', PropertyType.Income),
				required: true,
				controlName: 'income',
				type: 'dropdown',
				label: t('forms:AnnualIncome'),
				col: 12,
				value: data.employments[0].income,
				visible: true,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownAmountRange'),
			},
		],
	}
}
